import { CourseOverview, CourseOverviewProps, CourseStudy, CourseStudyProps } from "dashboard/ui";
import React, { useState } from "react";
import styled from "styled-components";
import { ICourse } from "utils/types";



const PreviewWrapper = styled.div`
  display: flex;
  justify-content: flex-end; /* Push preview to right side */
  padding: 16px;
  height: 100%;
`;

const PhoneFrame = styled.div`
  width: 375px; /* iPhone-ish width */
  height: 667px; /* iPhone-ish height */
  border: 12px solid #000; /* phone border */
  border-radius: 32px;
  background: #fff;
  position: relative;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  /* "notch" */
  &::before {
    content: "";
    width: 120px;
    height: 20px;
    background: #000;
    border-radius: 0 0 12px 12px;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
`;

const ScrollableContent = styled.div`
  flex: 1;
  padding: 16px;
  overflow-y: auto;
  font-family: "GolosText", sans-serif;

  /* reset some styles from rich text */
  h1, h2, h3, h4, h5, h6 {
    margin: 12px 0;
    font-weight: 600;
  }
  p {
    margin: 8px 0;
    line-height: 1.5;
  }
  img {
    max-width: 100%;
    border-radius: 8px;
  }
`;
type IPage = "overview"|"study"
export interface ArticlePreviewProps extends 
Omit<CourseOverviewProps, "course"|"courseId"|"onMoveToCourseStudy">,
Pick<CourseStudyProps, "onGetCourseModule"> {
  course?: ICourse

}
const ArticlePreview: React.FC<ArticlePreviewProps> = ({course, onGetCourseModule, ...courseOverviewProps }) => {
  const [page, setPage] = useState<IPage>("overview")
  return (
    <PreviewWrapper>
      <PhoneFrame>
        <ScrollableContent /* dangerouslySetInnerHTML={{ __html: htmlContent }}  */>
            {page === "overview" && <CourseOverview {...{ 
              course, 
              courseId: course?.id as string,
              ...courseOverviewProps,
              onMoveToCourseStudy: () => setPage("study"),
            }}/>}
            {page === "study" && <CourseStudy {...{
            onBackToHome() {
              
            },
            onTakeCourseQuiz() {
              
            },
            onBackToCourses() {
              setPage("overview");
            },
            courseId: course?.id as string,
            onBackToOverview: () => setPage("overview"),
            onGetCourseModule,
            async onGetUserCourse(courseId) {             
              return undefined;
            },
            async onCreateUserCourse(data) {
              return undefined;
            },
            async onUpdateUserCourse(userCourseId, data) {
              return undefined;
            },
          }}/>}
        </ScrollableContent>
      </PhoneFrame>
    </PreviewWrapper>
  );
};

export default ArticlePreview;
